import axios from 'axios';
const API = process.env.REACT_APP_API_BASE || 'http://127.0.0.1:8000';

function authHeader() {
  const auth = JSON.parse(localStorage.getItem('zocs_auth') || '{}');
  return auth.token ? { Authorization: `Bearer ${auth.token}` } : {};
}

export async function getCrmColumns() {
  const res = await axios.get(`${API}/crm/columns`, { headers: authHeader() });
  return res.data;
}

export async function queryCrm(body) {
  const res = await axios.post(`${API}/crm/query`, body, { headers: authHeader() });
  return res.data;
}

export async function getCrmCustomer(phone) {
  const res = await axios.get(`${API}/crm/customer/${encodeURIComponent(phone)}`, { headers: authHeader() });
  return res.data;
}

export async function startCrmRefresh() {
  const res = await axios.post(`${API}/crm/refresh`, {}, { headers: authHeader() });
  return res.data;
}

export async function getCrmRefreshStatus() {
  const res = await axios.get(`${API}/crm/refresh/status`, { headers: authHeader() });
  return res.data;
}

// Exports return a CSV file; errors come back as JSON inside the blob.
async function downloadCsv(path, body) {
  try {
    const res = await axios.post(`${API}${path}`, body, { headers: authHeader(), responseType: 'blob' });
    const cd = res.headers['content-disposition'] || '';
    const name = (cd.match(/filename="([^"]+)"/) || [])[1] || 'crm_export.csv';
    const url = URL.createObjectURL(res.data);
    const a = document.createElement('a');
    a.href = url; a.download = name; a.click();
    URL.revokeObjectURL(url);
  } catch (e) {
    const blob = e.response?.data;
    if (blob instanceof Blob) {
      let detail = 'Export failed';
      try { detail = JSON.parse(await blob.text()).detail || detail; } catch (_) { /* not JSON */ }
      throw new Error(detail);
    }
    throw e;
  }
}

export const exportCrmView = (body) => downloadCsv('/crm/export/view', body);
